import { Decoder, array, boolean, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../Resource/Decoders';
import { Report, ReportResource, Reports, ReportsResource } from '../Types';

export const reportDecoder: Decoder<Report> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('beta', field('beta', boolean))
  .assign('description', field('description', string));

const reportResourceDecoder: Decoder<ReportResource> = resourceDecoder(reportDecoder);

const reportsDecoder: Decoder<Reports> = succeed({}).assign(
  'reports',
  field('reports', array(reportResourceDecoder)),
);

export const reportsResourceDecoder: Decoder<ReportsResource> = resourceDecoder(reportsDecoder);
